import NavBar from './components/navbar/Navbar';
import Home from './pages/Home';
import NotFound from './pages/NotFound/notfound';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Seat from './pages/Seat/SeatMap';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Home />
            </>
          }
        />
        <Route
          path="/seat"
          element={
            <>
              <Seat />
            </>
          }
        />
        <Route
          path="*"
          element={
            <>
              <NavBar />
              <NotFound />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
